import type * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Hero } from '@xing-com/typography';

import type { ProductBenefitsProps } from './product-benefits';

const StyledHero = styled(Hero)<{ product: string }>`
  color: var(
    ${(props) =>
      `--xdlColor${props.product === 'projobs' ? 'ProJobs' : 'Premium'}`}
  );
`;

export const HeroHeader: React.FC<ProductBenefitsProps> = ({ product }) => {
  return (
    <StyledHero product={product} size="small" sizeConfined="medium" noMargin>
      <FormattedMessage
        id={`UPSELL_LOGGED_OUT_PAGE_PRODUCTS_${product.toLocaleUpperCase()}_MAIN_HEADLINE`}
      />
    </StyledHero>
  );
};
